import React, { Component } from 'react'
import Counsellorsidebar from './sidebar/sidebar'

class ethics extends Component {
    render() {
        return (
            <div>
                <Counsellorsidebar head="Diagnosis Criteria" />
                <div className="container" style={{ marginTop: "60px" }}>
                    <div className="row">
                    <div  className="col-12 col-md-10">
                        <ul >
                            <li>
                                Please be kind, supportive and respectful to every participant on
                                the forum at all time.
                            </li>
                            <li>Please do not use language that is inappropirate in nature.</li>
                            <li>Refrain from sharing similar links.</li>
                            <li>This is not a space for crisis management.</li>
                            <li>
                                Sharing of contact details is a personal choice, as such, open to
                                personal responsibility.
                            </li>
                            <li>Giving medical advice is not permitted.</li>
                            <li>
                                Members may discuss their current experiences in the context of
                                sharing their story and seeking support.
                            </li>
                        </ul>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

export default ethics
